import type { FlowDefinition } from '../types';
import { findConnectedBlockNodeSummary } from '../components/flow/connectedBlocks';
import { resolveFlowNodeSockets } from './flowNodeDefinitions';
import { resolveSectionOrPageFlow } from './flowBlockResolution';

export function resolveProductCardSelectActionTargets(
  flows: FlowDefinition[] | null | undefined,
  args: {
    blockId: string;
    blockType: 'product-card' | 'gallery';
    sectionId?: string | null;
  }
) {
  if (!Array.isArray(flows)) return null;

  const preferredFlow = resolveSectionOrPageFlow(flows, args.sectionId);
  const preferredFlowNode =
    preferredFlow?.nodes.find(
      (entry) => entry.blockId === args.blockId && entry.blockType === args.blockType
    ) ?? null;
  const summary =
    preferredFlow && preferredFlowNode
      ? {
          flow: preferredFlow,
          node: preferredFlowNode,
        }
      : !args.sectionId
        ? findConnectedBlockNodeSummary(
          { id: args.blockId, type: args.blockType },
          flows
        )
        : null;
  if (!summary) return null;

  const selectFieldId =
    summary.node.outputs.find((binding) => binding.socketId === 'select')?.fieldId ?? null;
  if (!selectFieldId) return null;

  const targetNodeIds = summary.flow.nodes
    .filter((node) => node.id !== summary.node.id)
    .filter((node) =>
      node.inputs.some((binding) => {
        if (binding.fieldId !== selectFieldId) return false;
        const socketDefinition = resolveFlowNodeSockets(node, summary.flow).find(
          (socket) => socket.direction === 'input' && socket.id === binding.socketId
        );
        return socketDefinition?.portKind === 'trigger';
      })
    )
    .map((node) => node.id);

  return {
    flowId: summary.flow.id,
    productCardNodeId: summary.node.id,
    selectFieldId,
    targetNodeIds,
  };
}
